import { render, staticRenderFns } from "./styleguide.vue?vue&type=template&id=5e4c748e&scoped=true"
import script from "./styleguide.vue?vue&type=script&lang=ts"
export * from "./styleguide.vue?vue&type=script&lang=ts"
import style0 from "./styleguide.vue?vue&type=style&index=0&id=5e4c748e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c748e",
  null
  
)

export default component.exports